/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */
import * as Types from 'src/graphql.generated'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

const defaultOptions = {} as const
export type GetAdvancedIntakeNoteComprehensiveDataQueryVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
}>

export type GetAdvancedIntakeNoteComprehensiveDataQuery = {
  __typename?: 'Query'
  intakeNoteComprehensivePatientData: {
    __typename?: 'IntakeNoteComprehensivePatientData'
    id: string
    overallInformation?: {
      __typename?: 'IntakeNoteComprehensiveOverallInformation'
      firstName?: string | null
      lastName?: string | null
      memberID?: string | null
      callStartTime?: string | null
      callEndTime?: string | null
      providerName?: string | null
      licenseType?: string | null
    } | null
    healthQuestionnaire?: {
      __typename?: 'IntakeNoteComprehensiveHealthQuestionnaire'
      phq9?: {
        __typename?: 'HealthQuestionnairePHQ9'
        PHQ9_QUESTION_1?: number | null
        PHQ9_QUESTION_2?: number | null
        PHQ9_QUESTION_3?: number | null
        PHQ9_QUESTION_4?: number | null
        PHQ9_QUESTION_5?: number | null
        PHQ9_QUESTION_6?: number | null
        PHQ9_QUESTION_7?: number | null
        PHQ9_QUESTION_8?: number | null
        PHQ9_QUESTION_9?: number | null
        PHQ9_SCORE?: number | null
      } | null
      gad7?: {
        __typename?: 'HealthQuestionnaireGAD7'
        GAD7_QUESTION_1?: number | null
        GAD7_QUESTION_2?: number | null
        GAD7_QUESTION_3?: number | null
        GAD7_QUESTION_4?: number | null
        GAD7_QUESTION_5?: number | null
        GAD7_QUESTION_6?: number | null
        GAD7_QUESTION_7?: number | null
        GAD7_SCORE?: number | null
      } | null
    } | null
    patientAnswers?: {
      __typename?: 'IntakeNoteComprehensivePatientAnswer'
      data: {
        __typename?: 'PatientAnswerData'
        currentLivingSituation?: string | null
        hasAllergies?: boolean | null
        listAllergies?: string | null
        functionalImpairments?: Array<string> | null
        medicalHistory?: Array<string> | null
        otherConditions?: string | null
        doctorName?: string | null
        doctorPhoneNumber?: string | null
        takesMedication?: boolean | null
        alcohol?: string | null
        marijuana?: string | null
        supportDetails?: string | null
        nonprescriptionDrugs?: string | null
        substanceUseSupport?: Array<string> | null
        tobaccoCigarettesChewVape?: string | null
        otherRecreationalSubstances?: string | null
        mentalIllnessHistoryInFamily?: boolean | null
        mentalIllnessDiagnosisFamily?: Array<string> | null
        hasSeenAMentalHealthProfessional?: boolean | null
        detailsOfExperienceWithMentalHealthProfessional?: string | null
        hasBeenHospitalized?: boolean | null
        detailsOfHospitalization?: string | null
        mainReasonForSeekingSupport?: string | null
        medications?: Array<{
          __typename?: 'PatientAnswerMedication'
          name?: string | null
          dosage?: string | null
          frequency?: string | null
        }> | null
      }
    } | null
  }
}

export const GetAdvancedIntakeNoteComprehensiveDataDocument = gql`
  query getAdvancedIntakeNoteComprehensiveData($uid: ID!) {
    intakeNoteComprehensivePatientData(uid: $uid) {
      id
      overallInformation {
        firstName
        lastName
        memberID
        callStartTime
        callEndTime
        providerName
        licenseType
      }
      healthQuestionnaire {
        phq9 {
          PHQ9_QUESTION_1
          PHQ9_QUESTION_2
          PHQ9_QUESTION_3
          PHQ9_QUESTION_4
          PHQ9_QUESTION_5
          PHQ9_QUESTION_6
          PHQ9_QUESTION_7
          PHQ9_QUESTION_8
          PHQ9_QUESTION_9
          PHQ9_SCORE
        }
        gad7 {
          GAD7_QUESTION_1
          GAD7_QUESTION_2
          GAD7_QUESTION_3
          GAD7_QUESTION_4
          GAD7_QUESTION_5
          GAD7_QUESTION_6
          GAD7_QUESTION_7
          GAD7_SCORE
        }
      }
      patientAnswers {
        data {
          currentLivingSituation
          hasAllergies
          listAllergies
          functionalImpairments
          medicalHistory
          otherConditions
          doctorName
          doctorPhoneNumber
          takesMedication
          medications {
            name
            dosage
            frequency
          }
          alcohol
          marijuana
          supportDetails
          nonprescriptionDrugs
          substanceUseSupport
          tobaccoCigarettesChewVape
          otherRecreationalSubstances
          mentalIllnessHistoryInFamily
          mentalIllnessDiagnosisFamily
          hasSeenAMentalHealthProfessional
          detailsOfExperienceWithMentalHealthProfessional
          hasBeenHospitalized
          detailsOfHospitalization
          mainReasonForSeekingSupport
        }
      }
    }
  }
`

/**
 * __useGetAdvancedIntakeNoteComprehensiveDataQuery__
 *
 * To run a query within a React component, call `useGetAdvancedIntakeNoteComprehensiveDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvancedIntakeNoteComprehensiveDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvancedIntakeNoteComprehensiveDataQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetAdvancedIntakeNoteComprehensiveDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAdvancedIntakeNoteComprehensiveDataQuery,
    GetAdvancedIntakeNoteComprehensiveDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetAdvancedIntakeNoteComprehensiveDataQuery,
    GetAdvancedIntakeNoteComprehensiveDataQueryVariables
  >(GetAdvancedIntakeNoteComprehensiveDataDocument, options)
}
export function useGetAdvancedIntakeNoteComprehensiveDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdvancedIntakeNoteComprehensiveDataQuery,
    GetAdvancedIntakeNoteComprehensiveDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetAdvancedIntakeNoteComprehensiveDataQuery,
    GetAdvancedIntakeNoteComprehensiveDataQueryVariables
  >(GetAdvancedIntakeNoteComprehensiveDataDocument, options)
}
export type GetAdvancedIntakeNoteComprehensiveDataQueryHookResult = ReturnType<
  typeof useGetAdvancedIntakeNoteComprehensiveDataQuery
>
export type GetAdvancedIntakeNoteComprehensiveDataLazyQueryHookResult = ReturnType<
  typeof useGetAdvancedIntakeNoteComprehensiveDataLazyQuery
>
export type GetAdvancedIntakeNoteComprehensiveDataQueryResult = Apollo.QueryResult<
  GetAdvancedIntakeNoteComprehensiveDataQuery,
  GetAdvancedIntakeNoteComprehensiveDataQueryVariables
>
